<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="complete-buy-point" style="margin-top: 20px">
      <Title v-if="isSuccess == 1" :jpn="t('ポイント購入完了')" />
      <Title v-if="isSuccess == 2" :jpn="t('購入失敗')" />
      <div class="area_box">
        <div class="flex-box">
          <div v-if="isSuccess == 1" class="text thanks immediate">
            <span>{{ t('ポイントのご購入ありがとうございました。') }}</span>
            <span>{{ t('引き続きDORIMAをお楽しみください。') }}</span>
          </div>
          <div v-if="isSuccess == 2" class="text thanks delay">
            <span>{{ t('決済に失敗しました。') }}</span>
            <span>{{ t('他の決済方法をご利用ください。') }}</span>
          </div>
        </div>
      </div>
      <BuyButton
        v-if="isExistPackId !== null && (!isExistPackId || !isMoreThanPackPoint)"
        class="purchase-btn square-button"
        :isArrow="false"
        :text="t('HOMEへ戻る')"
        @handleSquareBtnClick="goToTop"
    />
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import Title from '@/components/molecules/Title02.vue';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import BuyButton from '@/components/atoms/BuyButton.vue';
import t from '@/plugins/i18n';

export default {
  mixins: [t],
  components: {
    BaseTemplate,
    Title,
    BuyButton,
  },
  data: () => ({
    isSuccess: 0,
  }),

  computed: {
    ...mapGetters({
      pointEndResult: 'user/pointEndResult',
    }),
  },

  watch: {
    pointEndResult(newVal) {
      if (newVal) {
        this.$store.dispatch('user/setCurrentUser');
        if (newVal.pack_id) {
          this.$store.dispatch('pack/setCurrentPack', { packId: newVal.pack_id });
        }
      }
    },
  },

  created() {
    if (window.location.href.indexOf('complete-carrier') > 0) {
      this.isSuccess = 1;
    } else {
      this.isSuccess = 2;
    }
    this.$store.dispatch('user/setPointEndResult');
  },

  methods: {
    goToTop() {
      this.$router.push('/');
    },
  },
};
</script>

<style lang="scss" scoped>
.flex-box {
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.area_box {
  max-width: 680px;
  margin: 30px auto;
}
.complete-buy-point{
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1000px;
  min-height: 100%;
  padding-top: 0px;
  margin: 0px auto;
  text-align: center;
  // @include appendMap($backgroundStyleMap);
  .text.thanks{
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: $notoSans;
    font-size: 18px;
    line-height: 32.4px;
    // color: $white;
  }
  .square-button{
    width: 200px;
    margin: auto;
  }
}
@media screen and  (max-width: $tabletWidth) {
  .leaf_box {
    margin: 0 10px;
  }
}
</style>
